import { useMemo } from 'react';
import { clsx } from 'clsx';
import { TableRow, TableRowSpanningBoxProps } from '../../../../table/interfaces/table';
import { JobObject, JobObjectStage } from '../../../interfaces/job';
import { Table } from '../../../../table/Table';
import { JobObjectListGlobalContext } from './interface';
import { JobObjectStageFailures } from './JobObjectStageFailures';
import { objectStagesTableColumns } from './JobObjectStagesColumns';
import { jobObjectStagesDataId } from './DataId';

export function JobObjectStages({
  row,
  globalContext
}: TableRowSpanningBoxProps<JobObject, JobObjectListGlobalContext>) {
  const stageRows: TableRow<JobObjectStage>[] = useMemo(() => {
    return row.data.objectStages.map(stage => ({
      data: stage,
      tabIndex: 0,
      id: stage.stage
    }));
  }, [row]);

  if (!globalContext?.rowsExpandedState[row.data.objectName]) {
    return null;
  }

  return (
    <div
      data-id={jobObjectStagesDataId.container}
      className={clsx(!globalContext.isLoadOnly && 'bg-surface-overlay', 'p-2 pl-7')}
    >
      {globalContext.isLoadOnly ? (
        <JobObjectStageFailures
          row={stageRows.find(stage => stage.id === 'load')!}
          rowIndex={0}
          totalRows={1}
          globalContext={{
            jobId: globalContext?.jobId,
            objectId: row.data.objectId
          }}
        />
      ) : (
        <Table
          classes={{ containerClass: 'bg-surface border-radius-lg' }}
          columns={objectStagesTableColumns}
          renderHeader
          rows={stageRows}
          withoutShadow
          compactHeader
          forceFullWidth
          RowSpanningBox={JobObjectStageFailures}
          globalContext={{
            jobId: globalContext?.jobId,
            objectId: row.data.objectId
          }}
        />
      )}
    </div>
  );
}
